import { MRT_TableInstance } from 'material-react-table'
import { MutableRefObject } from 'react'

export const getFilteredTableData = <T extends Record<string, unknown>>(
    tableInstanceRef: MutableRefObject<MRT_TableInstance<T> | null>,
): T[] => {
    return tableInstanceRef.current?.getPrePaginationRowModel().rows.map((row) => row.original) ?? []
}
